import BaseApi from './BaseApi';

class ContactUsApi extends BaseApi {
  constructor(props) {
    super(props);

    this.API_NAME = 'contact-us';
  }

  async sendForm({ name, email, text }) {
    return this.postRequest('send', { data: { name, email, text } });
  }
}

export default new ContactUsApi();



// WEBPACK FOOTER //
// ./src/api/ContactUsApi.js